module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/modules/_redefine.js
// module id = 87
// module chunks = 0